import { 
  Play, Scan, Laptop, BarChart3, Check, User, Building2, 
  CheckCircle, Zap, FileUp, UserCheck, LayoutDashboard 
} from 'lucide-react';
import '../../../styles/LandingIntegrated.css';

const HomeContent = () => {
  return (
    <div className="li-pt-20">
      {/* Hero Section */}
      <section className="li-hero">
        <div className="li-container">
          <div className="li-hero-grid">
            <div className="li-hero-content">
              <div className="li-badge">
                <span style={{ display: 'flex', height: '0.5rem', width: '0.5rem', borderRadius: '50%', backgroundColor: '#7c3aed' }}></span>
                Trusted by 50+ Institutions
              </div>
              <h1 className="li-hero-title">
                The Smart Way to <br/>
                <span className="li-text-gradient">Ace Your Exams</span>
              </h1>
              <p className="li-hero-desc">
                From TNPSC to Bank exams, trueExams provides a seamless platform for OMR scanning, online tests, and instant results tracking.
              </p>
              <div className="li-hero-actions">
                <a href="#" className="li-hero-btn">
                  <Play size={20} fill="currentColor" />
                  Get it on Play Store
                </a>
                <div className="li-flex li-items-center li-gap-2" style={{ color: '#6b7280' }}>
                  <div className="li-flex" style={{ marginLeft: '-0.5rem' }}>
                    <img src="https://ui-avatars.com/api/?name=John+Doe&background=random" style={{ width: '2rem', height: '2rem', borderRadius: '50%', border: '2px solid white' }} alt="" />
                    <img src="https://ui-avatars.com/api/?name=Jane+Doe&background=random" style={{ width: '2rem', height: '2rem', borderRadius: '50%', border: '2px solid white', marginLeft: '-0.5rem' }} alt="" />
                    <img src="https://ui-avatars.com/api/?name=Alex+Smith&background=random" style={{ width: '2rem', height: '2rem', borderRadius: '50%', border: '2px solid white', marginLeft: '-0.5rem' }} alt="" />
                  </div>
                  <span style={{ fontSize: '0.875rem', fontWeight: 500 }}>Joined by 10,000+ Students</span>
                </div>
              </div>
            </div>
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: '-5rem', right: '-5rem', width: '16rem', height: '16rem', backgroundColor: '#ddd6fe', borderRadius: '50%', filter: 'blur(64px)', opacity: 0.3 }}></div>
              <img src="/Images/hero_banner.png" alt="trueExams Platform" style={{ position: 'relative', zIndex: 10, width: '100%', maxWidth: '42rem', margin: '0 auto', filter: 'drop-shadow(0 25px 25px rgba(0, 0, 0, 0.15))' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section id="features" className="li-section li-section-gray">
        <div className="li-container">
          <div className="li-section-header">
            <span className="li-section-badge">Core Features</span>
            <p className="li-section-title">Everything you need to succeed</p>
            <p style={{ color: '#4b5563' }}>Powerful tools designed for the modern-day competitive aspirant and progressive institutions.</p>
          </div>

          <div className="li-grid-3">
            {/* Feature 1: OMR Scanning */}
            <div className="li-card">
              <div className="li-card-icon li-icon-indigo">
                <Scan size={32} />
              </div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1rem' }}>OMR Scan & Upload</h3>
              <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
                No need for manual evaluation. Scan your physical OMR sheets through the app and get results instantly.
              </p>
            </div>

            {/* Feature 2: Online Tests */}
            <div className="li-card">
              <div className="li-card-icon li-icon-rose">
                <Laptop size={32} />
              </div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1rem' }}>Online Test Attempts</h3>
              <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
                Attempt mock exams in a real-time environment. Practice with TNSPSC, SSC, and Banking patterns.
              </p>
            </div>

            {/* Feature 3: Auto Analysis */}
            <div className="li-card">
              <div className="li-card-icon li-icon-emerald">
                <BarChart3 size={32} />
              </div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1rem' }}>Instant Auto-Analysis</h3>
              <p style={{ color: '#4b5563', lineHeight: 1.6 }}>
                Detailed feedback on performance, subject-wise analytics, and state-wide rankings immediately.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Feature Highlight: OMR */}
      <section className="li-section">
        <div className="li-container">
          <div className="li-hero-grid">
            <div style={{ gridOrder: 2 }}>
              <img src="/Images/omr_scan.png" alt="OMR Scanning Feature" style={{ borderRadius: '3rem', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', border: '8px solid white', width: '100%' }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div style={{ display: 'inline-block', alignSelf: 'flex-start', padding: '0.25rem 0.75rem', backgroundColor: '#ede9fe', color: '#7c3aed', borderRadius: '0.5rem', fontSize: '0.875rem', fontWeight: 700 }}>GAME CHANGER</div>
              <h2 style={{ fontSize: '2.25rem', fontWeight: 700, lineHeight: 1.2 }}>Hybrid Learning <br/> <span style={{ color: '#7c3aed' }}>At Your Fingertips</span></h2>
              <p style={{ color: '#4b5563', fontSize: '1.125rem' }}>
                We bridge the gap between traditional pen-and-paper exams and digital efficiency. 
              </p>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: '1rem', listStyle: 'none', padding: 0 }}>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                  <div style={{ marginTop: '0.25rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#f5f3ff', display: 'flex', alignItems: 'center', justifyCenter: 'center', color: '#7c3aed', flexShrink: 0 }}>
                    <Check size={16} />
                  </div>
                  <span style={{ color: '#374151' }}>Download Question Papers & OMR Sheets in PDF format.</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                  <div style={{ marginTop: '0.25rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#f5f3ff', display: 'flex', alignItems: 'center', justifyCenter: 'center', color: '#7c3aed', flexShrink: 0 }}>
                    <Check size={16} />
                  </div>
                  <span style={{ color: '#374151' }}>Scan physical sheets with high precision AI detection.</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                  <div style={{ marginTop: '0.25rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#f5f3ff', display: 'flex', alignItems: 'center', justifyCenter: 'center', color: '#7c3aed', flexShrink: 0 }}>
                    <Check size={16} />
                  </div>
                  <span style={{ color: '#374151' }}>Instant answer key comparison and score generation.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Roles & Solutions */}
      <section id="roles" className="li-section li-section-dark">
        <div style={{ position: 'absolute', top: 0, right: 0, width: '33%', height: '100%', backgroundColor: 'rgba(124, 58, 237, 0.1)', filter: 'blur(100px)' }}></div>
        <div className="li-container" style={{ position: 'relative', zIndex: 10 }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{ color: '#a78bfa', fontWeight: 700, marginBottom: '1rem' }}>TAILORED FOR EVERYONE</h2>
            <p style={{ fontSize: '2.25rem', fontWeight: 700 }}>Solutions for Students & Institutions</p>
          </div>

          <div className="li-grid-2">
            {/* Student Card */}
            <div className="li-dark-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2rem' }}>
                <div style={{ padding: '1rem', backgroundColor: 'rgba(124, 58, 237, 0.2)', borderRadius: '1rem', color: '#a78bfa' }}>
                  <User size={40} />
                </div>
                <span style={{ padding: '0.25rem 1rem', borderRadius: '9999px', border: '1px solid rgba(255, 255, 255, 0.2)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase' }}>For Students</span>
              </div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>Master Your Preparation</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#a78bfa' }} />
                  <span>State Selection</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#a78bfa' }} />
                  <span>Batch Selection</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#a78bfa' }} />
                  <span>Tutorial Videos</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#a78bfa' }} />
                  <span>Help & Support</span>
                </div>
              </div>
            </div>

            {/* Institution Card */}
            <div className="li-dark-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2rem' }}>
                <div style={{ padding: '1rem', backgroundColor: 'rgba(16, 185, 129, 0.2)', borderRadius: '1rem', color: '#34d399' }}>
                  <Building2 size={40} />
                </div>
                <span style={{ padding: '0.25rem 1rem', borderRadius: '9999px', border: '1px solid rgba(255, 255, 255, 0.2)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase' }}>For Institutions</span>
              </div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>Streamline Your Exams</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#34d399' }} />
                  <span>Dashboard Control</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#34d399' }} />
                  <span>Manage Batches</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#34d399' }} />
                  <span>Upload Materials</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#9ca3af' }}>
                  <CheckCircle size={16} style={{ color: '#34d399' }} />
                  <span>Approve Payments</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Flow Visualization */}
      <section id="pricing" className="li-section">
        <div className="li-container">
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{ fontSize: '2.25rem', fontWeight: 700, marginBottom: '1rem' }}>Simple & Flexible Payments</h2>
            <p style={{ color: '#4b5563' }}>Choose the model that suits your institution.</p>
          </div>

          <div className="li-payment-grid">
            {/* In-App Payment */}
            <div className="li-payment-card" style={{ position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, right: 0, padding: '1rem' }}>
                <span style={{ backgroundColor: '#7c3aed', color: 'white', padding: '0.25rem 0.75rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 700 }}>AUTOMATED</span>
              </div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>In-App Payment</h3>
              <p style={{ color: '#4b5563', marginBottom: '2rem', fontWeight: 500 }}>Student pays full fee (Institution Fee + ₹100 Platform Fee) through the app.</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <Zap size={20} style={{ color: '#7c3aed' }} />
                  <span style={{ fontWeight: 600 }}>Instant Access Approval</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <Zap size={20} style={{ color: '#7c3aed' }} />
                  <span style={{ fontWeight: 600 }}>No Manual Intervention Required</span>
                </div>
              </div>
            </div>

            {/* Hybrid Payment */}
            <div className="li-payment-card-plain">
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>Hybrid Payment</h3>
              <p style={{ color: '#4b5563', marginBottom: '2rem', fontWeight: 500 }}>Student pays Institution offline and ₹100 Platform Fee in-app.</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <FileUp size={20} style={{ color: '#9ca3af' }} />
                  <span style={{ color: '#4b5563' }}>Upload Receipt for Proof</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <UserCheck size={20} style={{ color: '#9ca3af' }} />
                  <span style={{ color: '#4b5563' }}>Institution Manual Approval</span>
                </div>
              </div>
            </div>
          </div>
          
          <div style={{ marginTop: '3rem', textAlign: 'center' }}>
            <p style={{ color: '#6b7280', fontStyle: 'italic' }}>* Platform fee of ₹100 is applicable per batch for all students.</p>
          </div>
        </div>
      </section>

      {/* Admin Brief */}
      <section className="li-section" style={{ backgroundColor: '#f5f3ff' }}>
        <div className="li-container">
          <div className="li-grid-2" style={{ backgroundColor: 'white', borderRadius: '3rem', padding: '3rem', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', alignItems: 'center', border: '1px solid #ede9fe' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <h2 style={{ fontSize: '2.25rem', fontWeight: 700, lineHeight: 1.2 }}>Powerful Admin Oversight</h2>
              <p style={{ color: '#4b5563', fontSize: '1.125rem' }}>
                Admins get complete control over the platform with state-wise analytics, revenue tracking, and institution management.
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                <div style={{ backgroundColor: '#f9fafb', padding: '1.5rem', borderRadius: '1.5rem' }}>
                  <div style={{ color: '#7c3aed', fontWeight: 700, fontSize: '2rem' }}>99.9%</div>
                  <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em' }}>Availability</div>
                </div>
                <div style={{ backgroundColor: '#f9fafb', padding: '1.5rem', borderRadius: '1.5rem' }}>
                  <div style={{ color: '#7c3aed', fontWeight: 700, fontSize: '2rem' }}>Real-time</div>
                  <div style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em' }}>Analytics</div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%', maxWidth: '24rem', aspectRatio: '1/1', background: 'linear-gradient(to bottom right, #7c3aed, #4f46e5)', borderRadius: '2rem', padding: '2.5rem', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', transform: 'rotate(3deg)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ width: '3rem', height: '3rem', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <LayoutDashboard size={24} />
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '0.875rem', opacity: 0.6 }}>Total Revenue</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>₹1,24,500</div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <div style={{ height: '0.5rem', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: '9999px' }}></div>
                  <div style={{ height: '0.5rem', width: '66%', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: '9999px' }}></div>
                  <div style={{ height: '0.5rem', width: '50%', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: '9999px' }}></div>
                </div>
                <div style={{ fontSize: '0.875rem', fontWeight: 500 }}>Admin Dashboard Overview</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeContent;
